import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { TaskPriority } from '@/types';

interface PriorityBadgeProps {
  priority: TaskPriority;
  size?: 'small' | 'medium';
}

const priorityConfig: Record<TaskPriority, { label: string; color: ChipProps['color']; bgClass: string }> = {
  [TaskPriority.P1]: {
    label: 'P1',
    color: 'error',
    bgClass: 'priority-p1',
  },
  [TaskPriority.P2]: {
    label: 'P2',
    color: 'warning',
    bgClass: 'priority-p2',
  },
  [TaskPriority.P3]: {
    label: 'P3',
    color: 'info',
    bgClass: 'priority-p3',
  },
  [TaskPriority.P4]: {
    label: 'P4',
    color: 'default',
    bgClass: 'priority-p4',
  },
};

/**
 * PriorityBadge Component
 * Visual indicator for task priority levels
 */
const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, size = 'small' }) => {
  const config = priorityConfig[priority];

  return (
    <Chip
      label={config.label}
      size={size}
      sx={{
        height: size === 'small' ? 20 : 24,
        fontSize: size === 'small' ? '0.675rem' : '0.75rem',
        fontWeight: 600,
        minWidth: 32,
        '& .MuiChip-label': {
          px: 1,
        },
      }}
      color={config.color}
      variant="filled"
    />
  );
};

export default PriorityBadge;
